import { Button, Drawer, Toolbar } from "devextreme-react";
import React, { useEffect, useState } from "react";
import SOPGrid from "./SOPGrid";
import SOPPDFViewer from "./SOPPDFViewer";

import axios from "axios";
import { Item } from "devextreme-react/toolbar";
import "./index.css";

import { useDispatch, useSelector } from "react-redux";
import Header from "../common/Header";
import { updateLoginPopupVisible } from "../common/Redux/login";
import { useNavigate } from "react-router-dom";

export default function SOPViewer() {
  const [opened, setOpened] = useState(true);

  const selectedDoc = useSelector((state) => state.SOPViewer.selectedDoc);
  const employeeNo = useSelector((state) => state.userInfo.employeeNo);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "SOP";

    if (employeeNo == null) {
      // dispatch(updateLoginPopupVisible(true));
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (selectedDoc) {
      if (
        (selectedDoc.type == "2" || selectedDoc.type == "3") &&
        selectedDoc.action == "download"
      ) {
        axios
          .get(
            // `http://218.232.108.62:9000/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${employeeNo}`,
            // `https://betree.beccocro.com:9000/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${employeeNo}`,
            `${process.env.REACT_APP_BECCO_API_URL}/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${employeeNo}`,
            {
              responseType: "blob",
            }
          )
          .then((result) => {
            if (result.headers["content-disposition"]) {
              const url = window.URL.createObjectURL(new Blob([result.data]));
              const link = document.createElement("a");
              link.href = url;

              let fileName = null;

              if (
                result.headers["content-disposition"].includes(
                  `filename*=UTF-8''`
                )
              ) {
                fileName = decodeURI(
                  result.headers["content-disposition"].split(
                    `filename*=UTF-8''`
                  )[1]
                );
              } else {
                fileName = result.headers["content-disposition"]
                  .split("=")[1]
                  .replace(/"/g, "");
              }

              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
            } else {
              console.log("[warning]");
            }
          });
      } else {
        // selectedDoc.type == "1" OR selectedDoc.type == "4"
        // if (selectedDoc.preSelectedDoc) {
        //   axios.put(
        //     `${process.env.REACT_APP_BECCO_API_URL}/api/SOPViewer/${selectedDoc.preSelectedDoc.docNo}/${selectedDoc.preSelectedDoc.ver}/${employeeNo}`
        //   );
        // }
      }
    }
  }, [selectedDoc]);

  const renderSOPGrid = () => {
    return (
      <SOPGrid
      // {...props}
      // setSelectedDoc={setSelectedDoc}
      // selectedDoc={selectedDoc}
      />
    );
  };

  const onClickMenu = () => {
    setOpened(!opened);
  };

  return (
    <React.Fragment>
      <Header title={"SOP"} menuDataSource={null} />
      {/* {employeeNo && ( */}
      <div>
        <Toolbar>
          <Item location="before">
            <Button
              // icon="menu"
              text={opened ? "Hide List" : "Show List"}
              type="success"
              stylingMode="outlined"
              onClick={onClickMenu}
            />
          </Item>
          {!opened && (
            <Item
              location={"before"}
              text={`${
                selectedDoc != null
                  ? `[${selectedDoc.docNo}] ${selectedDoc.docTitle}`
                  : //  "[" + selectedDoc.docNo + "] " + selectedDoc.docTitle
                    ``
              }`}
            />
          )}
        </Toolbar>
        <Drawer
          opened={opened}
          openedStateMode="shrink"
          position="left"
          revealMode="slide"
          // component={SOPGrid}
          render={renderSOPGrid}
        >
          {/* <div id="SOPPDFViwer" style={{ height: "100%" }}> */}
          <div id="SOPPDFViewer">
            {/* <SOPPDFViewer selectedDoc={selectedDoc} opened={opened} /> */}
            <SOPPDFViewer opened={opened} />
          </div>
        </Drawer>
      </div>
      {/* )} */}
    </React.Fragment>
  );
}
